import {useEffect, useState} from 'react';
import {StaticConfig} from '../../types/StaticConfig';
import {api, useApiContext} from '../../api';

export function useStaticConfig(): StaticConfig | null {
  const [config, setConfig] = useState<StaticConfig | null>(null);
  const ctx = useApiContext();

  useEffect(() => {
    (async () => {
      try {
        const config = await api.getStaticConfig(ctx);
        setConfig(config);
      } catch (e) {
        console.error(e);
      }
    })();
  }, [ctx]);

  return config;
}
